import React, { useMemo } from 'react';

import { useTabPages, TabPage } from '@ts-core/core/hooks/ui';

import GeneralRankingPage from '@ts-core/modules/rankings/pages/GeneralRankingPage';
import AssignmentsRankingPage from '@ts-core/modules/rankings/pages/AssignmentsRankingPage';
import SubjectsRankingPage from '@ts-core/modules/rankings/pages/SubjectsRankingPage';

export default function useRankingsPageTabs() {
  const pages = useMemo(
    (): TabPage[] => [
      { page: <GeneralRankingPage studentsMode />, tab: { label: 'General', slug: 'general' } },
      { page: <AssignmentsRankingPage studentsMode />, tab: { label: 'Entregas', slug: 'assignments' } },
      { page: <SubjectsRankingPage studentsMode />, tab: { label: 'Temas', slug: 'subjects' } },
    ],
    []
  );

  return useTabPages({ pages, slugParam: 'rankingType' });
}
